module.exports = __webpack_public_path__ + "img/logo.c196e0b9.svg";